// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"Spinner__Spinner___IKKHk","spinner":"Spinner__spinner___1XG1i","center":"Spinner__center___1ERMT"};